export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9334.66e2880e.jpg";